import gql from 'graphql-tag'

export const GET_CONTACT_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
  ) {
    getContactPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
      }
    ) {
      hasMore
      total
      items {
        id
        email
        homeId
        isMain
        showIn
        telNumber
        telegram
        whatsapp
      }
    }
  }
`

export const GET_CONTACT_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getContact (
      data: {
        id: $id
      }
    ) {
      id
      email
      homeId
      isMain
      showIn
      telNumber
      telegram
      whatsapp
    }
  }
`

export const GET_CONTACT_IMAGES_QUERY = gql`
  query {
    getContactImages {
      leftImage
      rightImage
    }
  }
`
